/**
 * Maps portfolio company IDs to their Shopify brand codes
 * (as stored in the brand_config SQL table).
 *
 * Portcos without a Shopify store return undefined.
 */

const portcoToBrand: Record<string, string> = {
  arg: "arg",
  "wellmore-fgo": "fgo",
  "wellmore-jade-leaf": "jl",
};

/** Display names for the coming-soon page */
const portcoDisplayNames: Record<string, string> = {
  arg: "ARG",
  "wellmore-fgo": "fgo",
  "wellmore-jade-leaf": "jl",
  "wellmore-glw": "Great Lakes Wellness",
  "wellmore-vega": "Vega",
  rawsugar: "Raw Sugar",
  "primal-harvest": "Primal Harvest",
};

export function getPortcoDisplayName(portcoId: string): string {
  return portcoDisplayNames[portcoId] || portcoId;
}

export function getBrandCode(portcoId: string): string | undefined {
  return portcoToBrand[portcoId];
}

/** Reverse lookup: Shopify brand code → portco ID */
const brandToPortco: Record<string, string> = Object.fromEntries(
  Object.entries(portcoToBrand).map(([k, v]) => [v, k]),
);

export function getPortcoIdFromBrand(brandCode: string): string | undefined {
  return brandToPortco[brandCode];
}

/**
 * Amazon brand code mapping.
 * Maps portco IDs to their Amazon brand_code in brand_config.
 */
const portcoToAmazonBrand: Record<string, string> = {
  "wellmore-jade-leaf": "jade-leaf-organics",
};

export function getAmazonBrandCode(portcoId: string): string | undefined {
  return portcoToAmazonBrand[portcoId];
}

/** Reverse lookup: Amazon brand code → portco ID */
const amazonBrandToPortco: Record<string, string> = Object.fromEntries(
  Object.entries(portcoToAmazonBrand).map(([k, v]) => [v, k]),
);

export function getPortcoIdFromAmazonBrand(
  brandCode: string,
): string | undefined {
  return amazonBrandToPortco[brandCode];
}
